import { Box, VStack, Heading, useToast, Center } from "@chakra-ui/react";
import SeasonForm from "./Form";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../consts/routes";
import useSeasons from "./hooks/useSeasons";
import { SeasonFormData } from "@olagg/validation-schemas/season.schema";

const CreateSeason = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const { createSeason } = useSeasons();

  const onSubmit = async (dataForm: SeasonFormData) => {
    try {
      await createSeason(dataForm);
      toast({
        title: 'Temporada',
        colorScheme: 'olaggPink',
        status: 'success',
        description: `Temporada creada con éxito`,
        position: 'bottom-right'
      });
      navigate(ROUTES.SEASONS.all);
    } catch (error: any) {
      toast({
        title: 'Error',
        colorScheme: 'olaggYellow',
        status: 'error',
        description: error.message || 'Error al crear la temporada',
        position: 'bottom-right'
      });
    }
  };

  return (
    <Center w={'full'} pb={4}>
      <VStack color={'white'} w={'full'}>
        <Heading my={2}>Crear temporada</Heading>
        <SeasonForm onSubmit={onSubmit} />
      </VStack>
    </Center>
  );
};

export default CreateSeason;